import component from './index.vue'

const Plugin = {
  install (Vue, options = {}) {
    if (this.installed) {
      return
    }
    this.installed = true
    this.event = new Vue({
      data: {
        isActivated: null
      }
    })
    Vue.component('megaMenu', component)
    // Vue.mixin({
    // })

    Vue.prototype.$megaMenu = {
    }
  }
}

// This exports the plugin object.
export default Plugin
